export type {
  TweetMediaDedupeDecision as MediaDedupeDecision,
  TweetMediaItem as MediaItem,
  TweetMediaMetadataEntry as MediaMetadataEntry,
  TweetMediaVariant as MediaItemVariant,
} from '@sweetistics/contracts/tweets-canonical';
export {
  TweetMediaDedupeDecisionSchema as MediaDedupeDecisionSchema,
  TweetMediaItemSchema as MediaItemSchema,
  TweetMediaMetadataEntrySchema as MediaMetadataEntrySchema,
  TweetMediaVariantSchema as MediaItemVariantSchema,
} from '@sweetistics/contracts/tweets-canonical';
